import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { RawHTML } from '@wordpress/element';
export default function MeetingSaveBlock({ attributes, }) {
    const { url } = attributes;
    if (url) {
        return (_jsx(RawHTML, { className: "wp-block-leadin-hubspot-meeting-block", children: `[hubspot url="${url}" type="meeting"]` }));
    }
    return null;
}
